import { css, cx } from 'emotion';
import {
	grey,
	lightGrey,
	headingSmallLight,
	mobileMaxWidthBreakpoint,
	textBlock,
} from 'inside-out/global-styles';
import MediaIcon from 'inside-out/images/media-icon.svg';
import MediaIconMobile from 'inside-out/images/media-icon-mobile.svg';

const padding = 26;

export const wrapperCardStyle = css({
	position: 'relative',
});

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
	height: '100%',
});

export const metaAudiencesStyle = css({
	lineHeight: '20px', // Vertical alignment with bookmark
	position: 'absolute',
	top: '22px',
	left: padding,
	'& svg:not(:last-child)': {
		marginRight: '6px',
	},
	zIndex: '2',
});

export const bookmarkButtonStyle = hasBackground =>
	css({
		background: 'none',
		border: 'none',
		padding: 0,
		display: 'inline-block',
		position: 'absolute',
		top: '22px',
		right: padding,
		zIndex: '2',
		filter: hasBackground ? 'brightness(2)' : null,
	});

export const titleStyle = cx(
	headingSmallLight,
	css({
		marginTop: padding,
		marginBottom: padding,
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '17px',
		},
	})
);

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: padding,
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			display: 'none',
		},
	})
);

export const metaBottomStyle = css({
	position: 'absolute',
	bottom: 0,
	left: padding,
	paddingTop: padding / 2,
	paddingBottom: padding / 2,
	width: `calc(100% - ${padding * 2}px)`,
	height: '36px',
	borderTop: `1px solid ${lightGrey}`,
	boxSizing: 'border-box',
	color: '#8A8B8C',
	display: 'flex',
	justifyContent: 'space-between',
});

export const metaDateStyle = css({
	fontSize: '12px',
	lineHeight: 1,
	margin: 0,
	textAlign: 'left',
});

export const metaViewsStyle = css({
	fontSize: '12px',
	lineHeight: 1,
	margin: 0,
	textAlign: 'right',
	'& svg': {
		marginRight: 2,
	},
});

export const wrapperInnerStyle = css({
	padding: `${padding}px`,
});

export const wrapperStyle = (background, hasVideo, hasDateOrViews) => {
	const base = {
		position: 'relative',
		textDecoration: 'none',
		border: `1px solid ${lightGrey}`,
		borderRadius: '6px',
		width: '100%',
		height: '100%',

		backgroundColor: '#fff',
		boxSizing: 'border-box',
		zIndex: '1',
		[`& .${wrapperInnerStyle}`]: {
			paddingBottom: `${hasDateOrViews ? 36 : padding}px`,
		},
	};
	if (!background) {
		return css(base);
	} else {
		return css({
			...base,
			paddingTop: '56.159420289855072%',
			[`& .${titleStyle}`]: {
				marginTop: 0,
			},
			'&:after': {
				borderRadius: '6px 6px 0 0',
				content: "' '",
				display: 'block',
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				paddingTop: '56.159420289855072%',
				...(hasVideo
					? {
							background: `url(${MediaIcon}), linear-gradient(
						rgba(0, 0, 0, 0.3),
						rgba(0, 0, 0, 0.3)
					  ), url('${background}')`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center center, center center, top center',
							backgroundSize: '56px 56px, cover, cover',
							[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
								backgroundImage: `url(${MediaIconMobile}), linear-gradient(
									rgba(0, 0, 0, 0.3),
									rgba(0, 0, 0, 0.3)
								  ), url('${background}')`,
								backgroundSize: '40px 40px, cover, cover',
							},
					  }
					: {
							background: `linear-gradient(
						rgba(0, 0, 0, 0.3),
						rgba(0, 0, 0, 0.3)
					  ), url('${background}')`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center center, top center',
							backgroundSize: 'cover, cover',
					  }),
			}
		});
	}
};



// WEBPACK FOOTER //
// ./src/components/shared/cards/resourceCard/styles.js